<eb-indicators [color]="color" [attr.data-cy]="'availability-' + color"></eb-indicators>
<ng-container *ngIf="availability?.statusCode !== null">
  <div [class]="{ 'product-availability__error': error }">
    {{ textId | cxTranslate: { date: (date | cxDate: 'mediumDate' : 'UTC') } }}
  </div>
</ng-container>
